import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ErrorText from "../../components/errorText";
import logger from "../../utils/logger";

interface Props {
  onSaveDrawerClose: (obj: any) => void;
  isActionError?: boolean;
  updateActionDays?: any; // CHANGED: Accept object instead of string to handle Facebook audience data
}

const ActionFacebookAudience: React.FC<Props> = ({
  onSaveDrawerClose,
  isActionError,
  updateActionDays = {} // CHANGED: Default to empty object instead of empty string
}) => {
  const StoreData = useSelector((state: any) => state?.rootReducers);
// CHANGED: Initialize from updateActionDays object properties
const [selectedAdAccount, setSelectedAdAccount] = useState(
  typeof updateActionDays === 'object' ? updateActionDays.adAccountId || "" : ""
);
const [audienceName, setAudienceName] = useState(
  typeof updateActionDays === 'object' ? updateActionDays.audienceName || "" : ""
);
  
  // Get Facebook integration from user integrations
  const userIntegrations = StoreData?.userData?.userDetails?.userIntegrations || [];
  const facebookIntegration = userIntegrations.find(
    (integration: any) => 
      integration.integration?.key === "facebook_audience" && 
      integration.isActive === true
  );
  
  const adAccounts = facebookIntegration?.details?.adaccounts || [];
  

  // NEW: Add useEffect to handle prop changes when drawer reopens
useEffect(() => {
  logger.log("ActionFacebookAudience: updateActionDays changed:", updateActionDays);
  
  if (typeof updateActionDays === 'object' && updateActionDays) {
    setSelectedAdAccount(updateActionDays.adAccountId || "");
    setAudienceName(updateActionDays.audienceName || "");
  } else {
    // Reset to empty values if no data
    setSelectedAdAccount("");
    setAudienceName("");
  }
}, [updateActionDays]);

  const handleSave = () => {
    if (!selectedAdAccount || !audienceName) {
      return;
    }
    
    const configData = {
      adAccountId: selectedAdAccount,
    
    };
    
    onSaveDrawerClose(configData);
  };
  
  return (
    <div className="row">
      <div className="form-group action_select">
        {facebookIntegration ? (
          <>
            <label>Select Facebook Ad Account</label>
            <select
              className="form-select"
              value={selectedAdAccount}
              onChange={(e) => setSelectedAdAccount(e.target.value)}
            >
              <option value="">Choose Ad Account</option>
              {adAccounts.map((account: any) => (
                <option key={account.id} value={account.id}>
                  {account.name}
                </option>
              ))}
            </select>
            
            <label>Audience Name</label>
            <input
              type="text"
              className="form-control"
              value={audienceName}
              onChange={(e) => setAudienceName(e.target.value)}
              placeholder="Enter custom audience name"
            />
            
            {isActionError && (
              <ErrorText message="Please select ad account and enter audience name" />
            )}
          </>
        ) : (
          <div className="alert alert-warning">
            Facebook integration not found. Please connect your Facebook account first.
          </div>
        )}
      </div>
      
      <div className="auto_action_form_btn">
        <button
          type="button"
          className="btn btn-primary-save"
          onClick={handleSave}
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default ActionFacebookAudience;